import { v4 as uuidv4 } from "uuid";

export const ACCOUNT_SELECTION_KEY = "cmp.activeAccountSelection";
const REVISION_KEY = "accountSelectionRevision";
const CURRENT_SELECTION_KEY = "accountSelectionSnapshot";

export const getCurrentAccountSelection = () => {
  const raw = sessionStorage.getItem(CURRENT_SELECTION_KEY);
  if (raw) {
    const selection = JSON.parse(raw);
    if (selection.userId === sessionStorage.getItem("userId")) return selection;
  }

  return {
    provider: localStorage.getItem("selectedProvider"),
    accountId: sessionStorage.getItem("activeAccountId"),
    accountName: localStorage.getItem("selectedAccountName"),
  };
};

export const getSharedAccountSelection = () => {
  const raw = localStorage.getItem(ACCOUNT_SELECTION_KEY);
  if (!raw) return null;

  const selection = JSON.parse(raw);
  if (!selection.revision || !selection.accountId || !selection.provider || !selection.userId) {
    throw new Error("The shared account selection is invalid. Please sign in again.");
  }
  return selection;
};

export const getPendingAccountSelection = () => {
  const selection = getSharedAccountSelection();
  if (
    !selection ||
    selection.userId !== sessionStorage.getItem("userId") ||
    selection.revision === sessionStorage.getItem(REVISION_KEY)
  ) {
    return null;
  }
  return selection;
};

export const applyAccountSelection = (selection) => {
  localStorage.setItem("selectedProvider", selection.provider);
  localStorage.setItem("selectedProviderId", selection.providerId);
  localStorage.setItem("selectedProjectId", selection.projectId);
  localStorage.setItem("selectedAccountName", selection.accountName);
  localStorage.setItem("selectedtenant", selection.tenantId);
  localStorage.setItem("catalogueSelection", "New");
  sessionStorage.setItem("activeAccountId", selection.accountId);

  const provider = selection.provider.toLowerCase();

  // Prevent stale provider-specific ids from leaking across provider switches.
  localStorage.removeItem("selectedSubscription");
  sessionStorage.removeItem("selectedSubscription");
  localStorage.removeItem("selectedGcpProjectId");

  if (provider === "aws") {
    localStorage.setItem("selectedAccountId", selection.accountId);
  } else if (provider === "azure") {
    localStorage.setItem("selectedAccountId", selection.accountId);
    localStorage.setItem("selectedSubscription", selection.accountId);
    sessionStorage.setItem("selectedSubscription", selection.accountId);
  } else {
    localStorage.removeItem("selectedAccountId");
    localStorage.setItem("selectedGcpProjectId", selection.accountId);
  }

  sessionStorage.setItem("userPermissions", JSON.stringify(selection.permissions));
  sessionStorage.setItem("userMenus", JSON.stringify(selection.menuItems));
  sessionStorage.setItem("userActions", JSON.stringify(selection.actions));
  ["role", "rolename"].forEach(key => {
    if (selection.activeRole) sessionStorage.setItem(key, selection.activeRole);
    else sessionStorage.removeItem(key);
  });
  sessionStorage.setItem(REVISION_KEY, selection.revision);
  sessionStorage.setItem(CURRENT_SELECTION_KEY, JSON.stringify(selection));
};

export const saveAccountSelection = (project, providerId, accountId, response) => {
  const userId = sessionStorage.getItem("userId");
  if (!userId || !accountId || !project.cloudProvider || !providerId) {
    throw new Error("Unable to save account selection. Please sign in and select an account again.");
  }
  const selection = {
    revision: uuidv4(),
    userId,
    provider: project.cloudProvider,
    providerId: String(providerId),
    accountId: String(response.activeAccountId || accountId),
    projectId: project.projectId ?? "",
    accountName: project.projectName ?? project.ProjectName ?? project.projectname ?? "Unnamed Project",
    tenantId: project.tenantID ?? "",
    permissions: response.permissions || [],
    menuItems: response.menuItems || [],
    actions: response.actions || {},
    activeRole: response.activeRole || null,
  };

  applyAccountSelection(selection);
  // Publish only after this tab has saved the complete successful selection.
  localStorage.setItem(ACCOUNT_SELECTION_KEY, JSON.stringify(selection));
  window.dispatchEvent(new Event("accountSwitched"));
  return selection;
};
